import {contextPath} from "site";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {FlightAnalyticsAircraftSummarySearchResult} from "./flight-analytics-aircraft-summary-search-result";

const apiURL = `${contextPath}/api/v2/analytics/aircraft-summary`;

@Injectable()
export class FlightAnalyticsAircraftSummaryService {
	constructor(private http: HttpClient) {}

	getFlightAnalyticsAircraftSummary(aircraftUuid: string, customerGuid: string = null): Observable<FlightAnalyticsAircraftSummarySearchResult> {
		var url = `${apiURL}?masterAircraftUuid=${aircraftUuid}`;
		if (customerGuid != null) {
			url += `&customerGuid=${customerGuid}`;
		}

		return this.http.get<FlightAnalyticsAircraftSummarySearchResult>(url)
			.map(response => FlightAnalyticsAircraftSummarySearchResult.fromJSON(response));
	}
}
